import styled from '@emotion/styled';
import theme from '../../shared/theme';

export const Container = styled.div({
  backgroundColor: theme.colors.light,
});

export const ChartWrapper = styled.div({
  margin: '0 auto',
  [`@media ${theme.breakpoints.above.small}`]: {
    maxWidth: 420,
  },
});

export const PieWrapper = styled.div({
  paddingTop: '2rem',
});
